import MainLayout from '../layout/main-layout';

export default function NoAccess() {
  return (
    <MainLayout>
      <div className="mx-auto max-w-lg py-10 text-center">
        <h1 className="mb-2 text-lg font-bold">Pas de permission</h1>
        <p className="text-sm text-gray-600">
          Vous n&apos;avez pas accès à cette page. Le menu reste disponible pour ouvrir une page autorisée.
        </p>
      </div>
    </MainLayout>
  );
}
